import type { CreateListenerOptions, Listener } from '@libp2p/interface'

export default function createListener (options: CreateListenerOptions): Listener {
  throw new Error('Not implemented')
}
